import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { MessageModel } from "@models/message.model";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MessagesService {
  constructor(private http: HttpClient) {}

  getMessages$(id: string): Observable<MessageModel[]> {
    return this.http
      .get<MessageModel[]>(`${environment.BASE_URL}client/${id}/message`)
      .pipe(map((data: MessageModel[]): MessageModel[] => data));
  }

  markAsRead$(id: string): Observable<unknown> {
    return this.http.patch(`${environment.BASE_URL}message/${id}`, null);
  }

  getDocument$(id: string, isPdf: boolean): Observable<Blob> {
    const url = isPdf ? `pdfattachment/${id}` : `attachment/${id}`;

    return this.http.get(`${environment.BASE_URL}${url}`, {
      responseType: "blob",
    });
  }
}
